import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { LiveRegion } from './live-region';

export const withLiveRegionProp = (WrappedComponent) => {
  const HoC = (props) => {
    const { screenReaderText, ...rest } = props;
    return (
      <React.Fragment>
        <WrappedComponent {...rest} />
        <LiveRegion screenReaderText={screenReaderText} {...rest} />
      </React.Fragment>
    );
  };
  HoC.displayName = `WithLiveRegion(${getDisplayName(WrappedComponent)})`;

  HoC.propTypes = {
    screenReaderText: PropTypes.string.isRequired,
  };

  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
